import apiServices from "../apiServices";
// Subscriptions API
export const subscriptionsApi = {
  getSubscriptionPlans: async (params = {}) => {
    const {
      page = 1,
      limit = 10,
      search = "",
      sortBy = "createdAt",
      sortOrder = "desc",
    } = params;

    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString());
    queryParams.append("limit", limit.toString());

    if (search && search.trim()) queryParams.append("search", search.trim());
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);

    const response = await apiServices.get(
      `/api/v1/subscription-plans?${queryParams.toString()}`
    );
    return response.data;
  },
  getSubscriptionPlanById: async (id) => {
    const response = await apiServices.get(`/api/v1/subscription-plans/${id}`);
    return response.data;
  },
  createSubscriptionPlan: async (data) => {
    const response = await apiServices.post(`/api/v1/subscription-plans`, data);
    return response.data;
  },
  updateSubscriptionPlan: async (id, data) => {
    const response = await apiServices.patch(
      `/api/v1/subscription-plans/${id}`,
      data
    );
    return response.data;
  },
  deleteSubscriptionPlan: async (id) => {
    const response = await apiServices.delete(
      `/api/v1/subscription-plans/${id}`
    );
    return response.data;
  },
};
